import moment from 'moment';
import 'moment/locale/id';

const getReportOperatorsResponse = (response) => {
  const result = response?.data;
  return {
    isDataExist: response?.data?.isDataExist || false,
    totalCount: response?.data?.totalData || 0,
    currentPage: response?.data?.currentPage || 0,
    totalPage: response?.data?.totalPage || 0,
    reports:
      result?.supervisorReports?.map((report) => {
        let parsedDate = moment(report?.reportPeriod, 'MMMM YYYY', 'en');
        if (!parsedDate.isValid()) {
          parsedDate = moment(report?.reportPeriod, 'MMMM YYYY', 'id');
        }

        return {
          ...report,
          reportPeriod: parsedDate.isValid() ? parsedDate.locale('id').format('MMMM YYYY') : report?.reportPeriod || '-',
        };
      }) ?? [],
  };
};

export default getReportOperatorsResponse;
